import React, {useContext, useEffect,useState} from  'react';
import { useParams } from 'react-router-dom';
import '../../../styles/devotionalWeeklyPage.css';
import WeeklyVideos from './videos';
import WeeklyAudios from './audios';
import WeeklyStotrasnSahasranamalu from './stotransahasra';
import Articles from './articles';
import { Helmet } from 'react-helmet-async';
import DevotionalBreadCrumb from '../devotionalBreadCrumb';
import { DeviceContext } from '..';
import PageAds from '../../common/pageAds';

   const  TitleMain ={
                        "56":"Shiva",
                        "57":"Hanuman",
                        "84": "Vinayakudu",
                        "85": "Saibaba",
                        "86": "Durga Devi",
                        "88": "Lakshmi Devi",
                        "121": "venkateswara swamy",

                    }

const DevotionalWeekly = ({ data }) => {
  const ssr = data?.[0]?.weeklyPage || {};
  const sectionOrder = ssr?.sectionOrder || [];
  const ssrCatId = ssr?.cat_id
  const cat_array = useParams().charecter
  const cat_id = cat_array.substring(cat_array.lastIndexOf('-')+1,cat_array.lastIndexOf('.html'))
  
  
   const {mobile,setMobile,containerRef} = useContext(DeviceContext)
 

         
                
               
         
  
   if (!cat_id) return null;       

  return (
    <div className='devotional-weekly'>
       
      <div className='container-fluid g-0'>
        <Helmet><title> {TitleMain[cat_id] ? TitleMain[cat_id] : ''} | Hindu Gods | Gods | Festivals | Hanuman Chalisa | Pravachanalu | Devotional Songs | Ramayanam | Bhaga</title></Helmet>
          <DevotionalBreadCrumb breadCrumb={TitleMain[cat_id] ? TitleMain[cat_id] : '' } />
    
          {cat_id !== '57' && (
          <WeeklyVideos
            cat_id={cat_id}
            ssrCatId ={ssrCatId}
            ssrData={Array.isArray(ssr.weeklyVideos) ? ssr.weeklyVideos : []}
          />
        )}

        <WeeklyAudios
          cat_id={cat_id}
          ssrCatId ={ssrCatId}
          ssrData={Array.isArray(ssr.weeklyAudios) ? ssr.weeklyAudios : []}
        />

        {cat_id !== '86' && (
          <WeeklyStotrasnSahasranamalu
            cat_id={cat_id}
            ssrData={ssr.weeklyStotras || {}}
          />
        )}

        <Articles
          cat_id={cat_id}
          ssrData={Array.isArray(ssr.articles) ? ssr.articles : []}
          limit={mobile ? 12 : 9}
        />
      </div>

        <PageAds mobile={mobile} containerRef={containerRef} />
    </div>
  );
};

export default DevotionalWeekly;